import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@babackapp/customer-ui/components/dialog";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import type { CartItem } from "@babackapp/return-widget-components/types";
import type { CatalogProductVariant } from "@babackapp/private-api-client/client/use-catalog-product";
import { useState } from "react";
import { buildCartItem } from "../../../lib/build-cart-item";
import { CatalogPickerAddView } from "./catalog-picker-add-view";

type Props = {
  shopId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Called once with the chosen article when the user confirms the dialog. */
  onConfirm: (item: CartItem) => void;
};

export function CatalogPickerDialog({ shopId, open, onOpenChange, onConfirm }: Props) {
  const t = useCustomText();
  const [isAdding, setIsAdding] = useState(false);

  async function handleAdd(
    productTitle: string,
    variant: CatalogProductVariant,
    imageUrl: string | null,
  ) {
    if (isAdding) return;
    setIsAdding(true);
    const item = await buildCartItem(shopId, productTitle, variant, imageUrl);
    setIsAdding(false);
    onConfirm(item);
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("catalogPicker.title")}</DialogTitle>
        </DialogHeader>
        <CatalogPickerAddView shopId={shopId} isAdding={isAdding} onAdd={handleAdd} />
      </DialogContent>
    </Dialog>
  );
}
